import { RootState } from 'global/state';



export const getCanSubmitUsersnapFeedback = (state: RootState) => state.loginState.permissions?.profile?.canSubmitUsersnapFeedback;
